"use strict";

exports.__esModule = true;
exports.default = void 0;
function $sort(_ref) {
  var sortItinerariesHashMap = _ref.sortItinerariesHashMap;
  return {
    isCheapest: function isCheapest(itineraryId) {
      var _sortItinerariesHashM;
      var cheapestItinerary = sortItinerariesHashMap === null || sortItinerariesHashMap === void 0 ? void 0 : (_sortItinerariesHashM = sortItinerariesHashMap.cheapest) === null || _sortItinerariesHashM === void 0 ? void 0 : _sortItinerariesHashM.id;
      return cheapestItinerary === itineraryId;
    },
    isShortest: function isShortest(itineraryId) {
      var _sortItinerariesHashM2;
      var shortestItinerary = sortItinerariesHashMap === null || sortItinerariesHashMap === void 0 ? void 0 : (_sortItinerariesHashM2 = sortItinerariesHashMap.shortest) === null || _sortItinerariesHashM2 === void 0 ? void 0 : _sortItinerariesHashM2.id;
      return shortestItinerary === itineraryId;
    },
    isRecommended: function isRecommended(itineraryId) {
      var _sortItinerariesHashM3;
      var recommendedItinerary = sortItinerariesHashMap === null || sortItinerariesHashMap === void 0 ? void 0 : (_sortItinerariesHashM3 = sortItinerariesHashMap.recommended) === null || _sortItinerariesHashM3 === void 0 ? void 0 : _sortItinerariesHashM3.id;
      return recommendedItinerary === itineraryId;
    },
    isCheapestDirect: function isCheapestDirect(itineraryId) {
      var _sortItinerariesHashM4;
      var cheapestDirectItinerary = sortItinerariesHashMap === null || sortItinerariesHashMap === void 0 ? void 0 : (_sortItinerariesHashM4 = sortItinerariesHashMap.cheapestDirect) === null || _sortItinerariesHashM4 === void 0 ? void 0 : _sortItinerariesHashM4.id;
      return cheapestDirectItinerary === itineraryId;
    }
  };
}
var _default = exports.default = $sort;